"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.vesselColumnFullWidthProps = exports.vesselColumnProps = exports.vesselTypes = void 0;
const constants_1 = require("utils/constants");
exports.vesselTypes = {
    SET_DATA_GRID: 'VESSEL TYPES GET DATA GRID',
    ON_PAGE_CHANGE: 'VESSEL TYPES ON PAGE CHANGE',
    ON_MUTATION_CLICK: 'VESSEL TYPES ON MUTATION',
    ON_SAVE_DATAITEM: 'VESSEL TYPES ON SAVE DATAITEM',
    ON_DELETE_DATAITEM: 'VESSEL TYPES ON DELETE DATAITEM',
    ON_CHANGE_DATAITEM: 'VESSEL TYPES ON CHANGE DATAITEM',
    TOGGLE_SUCCESS_MODAL: 'VESSEL TYPES SET SUCCESS MODAL',
    SET_DATA_CONTRACTOR: 'VESSEL TYPES GET DATA CONTRACTOR',
    ON_DELETE: 'VESSEL TYPES DELETE DATA CONTRACTOR',
    ON_FILTER_CHANGE: 'VESSEL TYPES ON FILTER CHANGE',
    ON_SORT_CHANGE: 'VESSEL TYPES ON SORT CHANGE',
    SET_ERROR: 'VESSEL TYPES ON SET ERROR',
};
exports.vesselColumnProps = [
    {
        show: true,
        field: 'contractor_name',
        title: 'Contractor',
        width: '400px',
        filter: 'text',
    },
    {
        show: true,
        field: 'vessel_no',
        title: 'Vessel No',
        width: '150px',
        filter: 'text',
    },
    {
        show: true,
        field: 'vessel_capacity',
        title: 'Vessel Capacity (TON)',
        width: '200px',
        filter: 'numeric',
    },
    {
        show: true,
        field: 'modified_date',
        title: 'Modified Date',
        width: '220px',
        filter: 'date',
        format: `${constants_1.formatGridDate.ddMMYYYY} ${constants_1.formatGridDate.hhMM}`,
    },
    {
        show: true,
        field: 'modified_by',
        title: 'Modified By',
        width: '180px',
        filter: 'text',
    },
    {
        show: true,
        field: 'is_active',
        title: 'Status',
        width: '140px',
        filter: 'boolean',
    },
];
exports.vesselColumnFullWidthProps = [...exports.vesselColumnProps];
exports.vesselColumnFullWidthProps[0] = {
    show: true,
    field: 'contractor_name',
    title: 'Contractor',
    width: 'auto',
    filter: 'text',
};
